import {
  FETCH_START,
  FETCH_END,
  FETCH_ERROR,
  FETCH_CANCEL,
} from '../../actions';


const loadingReducer = (previousState = false, { type }) => {
  switch (type) {
    case FETCH_START:
      return true;
    case FETCH_END:
    case FETCH_ERROR:
    case FETCH_CANCEL:
      return false;
    default:
      return previousState;
  }
};

export default loadingReducer;
